import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import {render} from "react-dom";
import {Provider} from 'react-redux'
import {BrowserRouter as Router} from "react-router-dom";
import * as serviceWorker from './serviceWorker';

import {loadProductData, setAttributes} from './redux/actions';
import {getProductId, getRouterBasename} from "./helpers/common";

import store from './redux/store'
import attributes from './data/attributes';

import App from './App';

store.dispatch(loadProductData(getProductId()));
store.dispatch(setAttributes(attributes));

render(
  <Provider store={store}>
    <Router basename={getRouterBasename()}>
      <App/>
    </Router>
  </Provider>
  , document.getElementById("root"));


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
